module.exports = "/_next/static/images/ISPConstr-1f8c5b20e44a27e23f43f85fc844cefb.webp";